import { io } from "socket.io-client";
import { store } from "@/store";
import { api } from "@/libs/config";

/**
 * Admin socket connection (WeAll Team inbox). One shared connection for the whole admin session; the server puts
 * every admin token into the `weall_team_admins` room, so nothing needs to be joined by hand.
 * The token is read again on every (re)connect, so a refreshed login is picked up automatically.
 */
export const WEALL_TEAM_EVENTS = {
  NEW_MESSAGE: "WEALL_TEAM_NEW_MESSAGE",
  CONVERSATION_UPDATED: "WEALL_TEAM_CONVERSATION_UPDATED",
  UNREAD_COUNT: "WEALL_TEAM_UNREAD_COUNT",
  MESSAGE_DELIVERED: "MESSAGE_DELIVERED",
  MESSAGE_SEEN: "MESSAGE_SEEN",
};

let socket = null;

export const connectAdminSocket = () => {
  if (socket) return socket;

  socket = io(api.api_base, {
    transports: ["websocket", "polling"],
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 10000,
    auth: (cb) => cb({ token: store.getState().user?.accessToken || "" }),
  });

  return socket;
};

export const getAdminSocket = () => socket;

export const disconnectAdminSocket = () => {
  if (!socket) return;
  socket.removeAllListeners();
  socket.disconnect();
  socket = null;
};
